module.exports = __webpack_public_path__ + "static/media/TrustStructure.9766f726.png";